import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

interface AdminSidebarProps {
  onLinkClick?: () => void;
}

export default function AdminSidebar({ onLinkClick }: AdminSidebarProps) {
  return (
    <aside className="w-64 border-r bg-background p-4">
      <nav className="flex flex-col gap-2">
        <h2 className="mb-2 px-4 text-lg font-semibold">Dashboard</h2>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin" onClick={onLinkClick}>Overview</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/feeds" onClick={onLinkClick}>Feeds</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/categories" onClick={onLinkClick}>Categories</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/users" onClick={onLinkClick}>Users</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/settings" onClick={onLinkClick}>Settings</Link>
        </Button>
        <Separator className="my-4" />
        <h2 className="mb-2 px-4 text-lg font-semibold">System</h2>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/workers" onClick={onLinkClick}>Workers</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/logs" onClick={onLinkClick}>Logs</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/analytics" onClick={onLinkClick}>Analytics</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/protected" onClick={onLinkClick}>Protected Content</Link>
        </Button>
        <Button asChild variant="ghost" className="justify-start">
          <Link to="/admin/auth-test" onClick={onLinkClick}>Auth Test</Link>
        </Button>
      </nav>
    </aside>
  );
}
